/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_decrease_ex4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From 500 to 350: ((500 − 350) ÷ 500) × 100 = 30% decrease.`)
};

const es_pct_decrease_ex4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De 500 a 350: ((500 − 350) ÷ 500) × 100 = 30% de disminución.`)
};

const de_pct_decrease_ex4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Von 500 auf 350: ((500 − 350) ÷ 500) × 100 = 30% Rückgang.`)
};

const nl_pct_decrease_ex4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Van 500 naar 350: ((500 − 350) ÷ 500) × 100 = 30% daling.`)
};

const fr_pct_decrease_ex4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De 500 à 350 : ((500 − 350) ÷ 500) × 100 = diminution de 30 %.`)
};

const it_pct_decrease_ex4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Da 500 a 350: ((500 − 350) ÷ 500) × 100 = calo del 30%.`)
};

const pt_br2_pct_decrease_ex4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De 500 para 350: ((500 − 350) ÷ 500) × 100 = 30% de diminuição.`)
};

const pt_pct_decrease_ex4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De 500 para 350: ((500 − 350) ÷ 500) × 100 = 30% de diminuição.`)
};

const ja_pct_decrease_ex4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`500から350へ: ((500 − 350) ÷ 500) × 100 = 30%減少。`)
};

const zh_pct_decrease_ex4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从 500 到 350：((500 − 350) ÷ 500) × 100 = 减少 30%。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_decrease_ex4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_decrease_ex4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_decrease_ex4", locale)
	if (locale === "en") return en_pct_decrease_ex4(inputs)
	if (locale === "es") return es_pct_decrease_ex4(inputs)
	if (locale === "de") return de_pct_decrease_ex4(inputs)
	if (locale === "nl") return nl_pct_decrease_ex4(inputs)
	if (locale === "fr") return fr_pct_decrease_ex4(inputs)
	if (locale === "it") return it_pct_decrease_ex4(inputs)
	if (locale === "pt-BR") return pt_br2_pct_decrease_ex4(inputs)
	if (locale === "pt") return pt_pct_decrease_ex4(inputs)
	if (locale === "ja") return ja_pct_decrease_ex4(inputs)
	return zh_pct_decrease_ex4(inputs)
};